import {
  ToastProvider,
  ToastViewport,
  Toast,
  ToastTitle,
  ToastDescription,
  ToastClose,
} from "@sonify/web-ui";
import { useToasts, useDismissToast } from "@/shared/hooks/use-toast";

export function Toaster() {
  const toasts = useToasts();
  const dismiss = useDismissToast();

  return (
    <ToastProvider duration={3000}>
      {toasts.map((t) => (
        <Toast
          key={t.id}
          variant={t.variant}
          onOpenChange={(open) => {
            if (!open) dismiss(t.id);
          }}
        >
          <ToastTitle>{t.title}</ToastTitle>
          {t.description && <ToastDescription>{t.description}</ToastDescription>}
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport position="bottom-right" />
    </ToastProvider>
  );
}
